/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFavoriteListFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeFavoriteList, serializeSetAsDefaultRequest, type ErrorResponse, type FavoriteList, type InternalErrorResponse, type SetAsDefaultRequest } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/favorites/{customerNumber-id}/set-default
 */
export interface SetDefaultRequestBuilder extends BaseRequestBuilder<SetDefaultRequestBuilder> {
    /**
     * Marks this list as the customer's default — the one GET /api/favorites/{customerNumber}/default returns. A customer has at most one default, so the flag is first cleared on whichever list held it; that list keeps its name and every item and simply stops being the default. Only the flag moves — no items are copied between lists. Setting the current default again is harmless. Unlike the rest of the favorites endpoints this route carries no customer number: the list is resolved within the caller's organization and the customer is taken from the list itself.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: SetAsDefaultRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FavoriteList | undefined>;
    /**
     * Marks this list as the customer's default — the one GET /api/favorites/{customerNumber}/default returns. A customer has at most one default, so the flag is first cleared on whichever list held it; that list keeps its name and every item and simply stops being the default. Only the flag moves — no items are copied between lists. Setting the current default again is harmless. Unlike the rest of the favorites endpoints this route carries no customer number: the list is resolved within the caller's organization and the customer is taken from the list itself.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: SetAsDefaultRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SetDefaultRequestBuilderUriTemplate = "{+baseurl}/api/favorites/{customerNumber%2Did}/set-default";
/**
 * Metadata for all the requests in the request builder.
 */
export const SetDefaultRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: SetDefaultRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSetAsDefaultRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
